import { render, staticRenderFns } from "./SearchDentist.vue?vue&type=template&id=b7a27668&"
import script from "./SearchDentist.vue?vue&type=script&lang=js&"
export * from "./SearchDentist.vue?vue&type=script&lang=js&"
import style0 from "./SearchDentist.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports